import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getUser, updateAccessToken } from './_redux/_slices/authentication_slice';
import { useAppDispatch } from './_redux/hooks';

const OauthRedirect = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(location.search);
  const id = params.get('id');
  const accessToken = params.get('token');
  const client = params.get('client');
  const email = params.get('email');
  const redirect_url = params.get('redirect_url');
  const expiry = params.get('expiry');

  useEffect(() => {
    dispatch(updateAccessToken({ accessToken: accessToken as any, client: client as any, email: email as any, expiry: expiry as any }));
    dispatch(getUser({ id: id as any, redirect: redirect_url }));
  });

  return <div></div>;
};

export default OauthRedirect;
